import * as yup from "yup";
import { formatarValorMonetarioInputNumerico } from "shared/util/functions/formatacoesDeValores/FormatarValores";
import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import { RegistroImpostoSelectAsyncDTO } from "types/dto/imposto/RegistroImpostoSelectAsyncDTO";
import { SelectOptionType } from "types/select/SelectOptionType";

export const CadastrarDespesaRetencaoGroupPaySchema = yup.object().shape({
  valorBase: yup
    .number()
    .transform((_, originalValue) => {
      let valor = originalValue ? originalValue : "0";
      return typeof valor === "number" ? valor : formatarValorMonetarioInputNumerico(valor);
    })
    .nullable(),
  imposto: yup.mixed<SelectOptionType<RegistroImpostoSelectAsyncDTO>>().nullable(),
  mesCompetencia: yup
    .date()
    .nullable()
    .when("imposto", {
      is: (imposto: SelectOptionType<RegistroImpostoSelectAsyncDTO>) => !!imposto?.value?.impostoId,
      then: (schema) => schema.required(mensagemDeErroPadrao("Mês competência")).typeError("Informe uma data válida"),
    }),
  dataVencimento: yup
    .date()
    .nullable()
    .when("imposto", {
      is: (imposto: SelectOptionType<RegistroImpostoSelectAsyncDTO>) => !!imposto?.value?.impostoId,
      then: (schema) =>
        schema.required(mensagemDeErroPadrao("Data de vencimento")).typeError("Informe uma data válida"),
    }),
  valor: yup
    .number()
    .transform((_, originalValue) => {
      let valor = originalValue ? originalValue : "0";
      return typeof valor === "number" ? valor : formatarValorMonetarioInputNumerico(valor);
    })
    .nullable()
    .when("imposto", {
      is: (imposto: SelectOptionType<RegistroImpostoSelectAsyncDTO>) => !!imposto?.value?.impostoId,
      then: (schema) =>
        schema
          .required(mensagemDeErroPadrao("Valor"))
          .positive("O valor deve ser maior do que 0!")
          .typeError("Informe um valor válido"),
    }),
  formaPagamento: yup.mixed<SelectOptionType<string>>().nullable(),
  tipoFormaPagamentoPix: yup
    .string()
    .nullable()
    .when("formaPagamento", {
      is: (formaPagamento: { value: string } | null) => formaPagamento?.value === "PIX",
      then: (schema) =>
        schema
          .required("Escolha uma forma de pagamento PIX")
          .oneOf(["TRANSFERENCIA", "QR_CODE"], "Selecione uma opção válida"),
    }),
  codigoCopiaColaPix: yup
    .string()
    .nullable()
    .when("tipoFormaPagamentoPix", {
      is: "QR_CODE",
      then: (schema) => schema.required(mensagemDeErroPadrao("Código Copia e Cola PIX")),
    }),
  numeroCheque: yup
    .string()
    .nullable()
    .when(["formaPagamento"], ([tipo], schema) => {
      return tipo?.value === "CHEQUE" ? schema.required(mensagemDeErroPadrao("Número do cheque")) : schema;
    }),
});
